import {
  CrmLayoutCollapseComponent,
  CrmLayoutLogoComponent,
  CrmLayoutMenuComponent,
  CrmLayoutProfileComponent,
  CrmLayoutProfileItemKey,
  crmLayoutSidebarOnly,
  CrmLayoutV2Config,
} from '@touch4it/ng-swp/layout-v2';

import { MenuProvider } from '~/shared/providers/menu.provider';
import { WorkspacesSelectorComponent } from '~/features/workspaces/selector/workspaces-selector.component';
import { LogoProvider } from '~/shared/providers/logo.provider';

export const layoutConfig: CrmLayoutV2Config = {
  ...crmLayoutSidebarOnly,
  siderLeft: {
    ...crmLayoutSidebarOnly.siderLeft,
    fragments: [
      { key: 'logo', content: CrmLayoutLogoComponent, provider: LogoProvider },
      { key: 'workspace', content: WorkspacesSelectorComponent },
      { key: 'menu', content: CrmLayoutMenuComponent, provider: MenuProvider },
      { key: 'collapse', content: CrmLayoutCollapseComponent },
      { key: 'profile', content: CrmLayoutProfileComponent },
    ],
  },
  content: undefined,
  logo: {
    smallLogoPath: '/assets/images/logo.svg',
    defaultLogoPath: '/assets/images/logo.svg',
  },
  menu: {
    items: [
      {
        key: 'knowledgebase.title',
        routeKey: 'knowledgebase',
        icon: {
          base: 'icons:bling_line',
          selected: 'icons:bling_fill',
        },
      },
      {
        key: 'chatrooms.title',
        routeKey: 'chatrooms',
        icon: {
          base: 'icons:news_line',
          selected: 'icons:news_fill',
        },
        role: ['admin'],
      },
      {
        key: 'users.title',
        routeKey: 'users',
        icon: {
          base: 'icons:group_line',
          selected: 'icons:group_fill',
        },
        role: ['admin', 'management'],
      },
    ],
  },
  profile: {
    ...crmLayoutSidebarOnly.profile,
    profilePath: '/users/profile',
    items: [
      {
        key: CrmLayoutProfileItemKey.PROFILE,
        title: 'crm.layout.profile.profile',
      },
      {
        key: CrmLayoutProfileItemKey.LOGOUT,
        title: 'crm.layout.profile.logout',
      },
    ],
  },
};
